// src/components/common/ThemeToggle/ThemeToggle.jsx
import React from 'react';
import { IconButton, Tooltip, Box, Typography } from '@mui/material';
import { LightMode, DarkMode } from '@mui/icons-material';
import { useSelector, useDispatch } from 'react-redux';
import { toggleTheme } from '../../../store/slices/uiSlice';

const ThemeToggle = ({ showLabel = false, size = 'medium' }) => {
  const dispatch = useDispatch();
  const { mode } = useSelector((state) => state.ui);

  const handleToggle = () => {
    dispatch(toggleTheme());
  };

  const isDark = mode === 'dark';

  if (showLabel) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          p: 1,
          borderRadius: 1,
          cursor: 'pointer',
          '&:hover': {
            bgcolor: 'action.hover',
          },
        }}
        onClick={handleToggle}
      >
        {isDark ? (
          <DarkMode color="primary" fontSize={size} />
        ) : (
          <LightMode color="primary" fontSize={size} />
        )}
        <Typography variant="body2" color="text.primary">
          {isDark ? 'Dark Mode' : 'Light Mode'}
        </Typography>
      </Box>
    );
  }

  return (
    <Tooltip title={`Switch to ${isDark ? 'light' : 'dark'} mode`}>
      <IconButton
        onClick={handleToggle}
        color="inherit"
        size={size}
        sx={{
          minHeight: 44,
          minWidth: 44,
        }}
      >
        {isDark ? <DarkMode /> : <LightMode />}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle;